import script from "./Builds.vue?vue&type=script&setup=true&lang=js"
export * from "./Builds.vue?vue&type=script&setup=true&lang=js"

import "./Builds.vue?vue&type=style&index=0&id=7f666ffc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f666ffc"]])

export default __exports__